/**
 * Created by Daniela on 19/12/2016.
 */
/**
 * Created by Daniela on 19/12/2016.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { UtilService } from "../../../shared/services/util.service";
import { modelosModuleName, modelosStorage } from "../shared/data.service";
import { editRoute, newRoute } from "../../../shared/services/data.service";
import { Modelo } from "../shared/modelo.model";
import { ModeloApiService } from "../shared/modelo-api.service";
import { ModeloService } from "../shared/modelo.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { ModeloNavigationService } from "../shared/modelo-navigation.service";
import { Marca } from "../../marcas/shared/marca.model";
import { Categoria } from "../../categorias/shared/categoria.model";
import { BemTipo } from "../../bem-tipos/shared/bem-tipos.model";
import { BemSubtipo } from "../../bem-subtipos/shared/bem-subtipo.model";
import { TipoDeslocamento } from "../../../viagens/deslocamento-tipos/deslocamento-tipos.model";
import { MarcaNavigationService } from "../../marcas/shared/marca-navigation.service";
import { MarcaApiService } from "../../marcas/shared/marca-api.service";
import { marcasStorage, marcasQuery } from "../../marcas/shared/data.service";
import { bemTiposStorage, bemTiposQueryCategoria } from "../../bem-tipos/shared/data.service";
import { BemTiposNavigationService } from "../../bem-tipos/shared/bem-tipos-navigation.service";
import { CategoriaApiService } from "../../categorias/shared/categoria-api.service";
import { DeslocamentoTiposApiService } from "../../../viagens/deslocamento-tipos/deslocamento-tipos-api.service";
import { BemSubtipoApiService } from "../../bem-subtipos/shared/bem-subtipo-api.service";
import { BemTiposApiService } from "../../bem-tipos/shared/bem-tipos-api.service";
import { DeslocamentoTiposService } from "../../../viagens/deslocamento-tipos/deslocamento-tipos.service";
import { CategoriaCnh } from "../../cnh/categorias-cnh/shared/categoria-cnh.model";
import { CategoriaCnhApiService } from "../../cnh/categorias-cnh/shared/categoria-cnh-api.service";
import { FormaControleApiService } from "../../formas-controle/shared/forma-controle-api.service";
import { FormaControle } from "../../formas-controle/shared/forma-controle.model";

@Component({
    template: require('./modelo-form.component.html'),
    styles: [require('./modelo-form.component.css')]
})
export class ModeloFormComponent implements OnInit {
    modelosModule:any = modelosModuleName;
    formObject:any = new Modelo();
    marcaObject:any = new Marca();
    categoriaObject:any = new Categoria();
    bemTipoObject:any = new BemTipo();
    bemSubtipoObject:any = new BemSubtipo();
    deslocamentoTipoObject:any = new TipoDeslocamento();
    categoriaCnhObject:any = new CategoriaCnh();
    formaControleObject:any = new FormaControle();
    actionTitle:string;
    submitted:boolean = false;
    btnSaveDisabled:boolean = false;
    showSelectMarca:boolean = false;

    marcaSelectId:string = 'marcaSelect';
    marcaQuery: any = marcasQuery;
    bemTipoSelectId:string = 'bemTipo';
    bemTipoQuery: any = bemTiposQueryCategoria;

    categoriasList: Categoria[] = [];
    bemSubtiposList: BemSubtipo[] = [];
    deslocamentoTiposList: TipoDeslocamento[] = [];
    formasControleList: any[] = [];
    categoriasCnhList: any[] = [];

    form:FormGroup;
    ativo = new FormControl('');
    modelo = new FormControl('', Validators.required);
    marca = new FormControl('', Validators.required);
    categoria = new FormControl('', Validators.required);
    bemTipo = new FormControl('', Validators.required);
    bemSubtipo = new FormControl();
    deslocamentoTipo = new FormControl('');
    consumoEsperadoMaximo = new FormControl('');
    consumoEsperadoMinimo = new FormControl('');
    formaControle = new FormControl('');
    motorizado = new FormControl('');
    numeroEixos = new FormControl('');
    categoriaCnh = new FormControl('');
    potencia = new FormControl('');
    cilindradas = new FormControl('');
    consumoMedio = new FormControl('');
    capacidadeTanque  = new FormControl('');
    tipoEixo = new FormControl('');
    numeroPassageiros = new FormControl('');
    capacidadeCarga = new FormControl('');

    private returnToOtherForm:boolean = false;
    private otherForm:string;
    private responsModelo:any;

    constructor(
        private _route:ActivatedRoute,
        private _utilService:UtilService,
        private _modelosService: ModeloService,
        private _modeloApiService: ModeloApiService,
        private _modeloNavigationService: ModeloNavigationService,
        private _marcaNavigationService: MarcaNavigationService,
        private _marcaApiService: MarcaApiService,
        private _bemTipoApiService: BemTiposApiService,
        private _bemTipoNavigationService: BemTiposNavigationService,
        private _categoriaApiService: CategoriaApiService,
        private _categoriaCnhApiService: CategoriaCnhApiService,
        private _deslocamentoTipoApiService: DeslocamentoTiposApiService,
        private _deslocamentoTipoService: DeslocamentoTiposService,
        private _bemSubtipoApiService: BemSubtipoApiService,
        private _autocompleteService:AutoCompleteService,
        private _formaControleApiService:FormaControleApiService,
        private _fb:FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            modelo: this.modelo,
            marca: this.marca,
            categoria: this.categoria,
            bemTipo: this.bemTipo,
            bemSubtipo: this.bemSubtipo,
            deslocamentoTipo: this.deslocamentoTipo,
            consumoEsperadoMaximo: this.consumoEsperadoMaximo,
            consumoEsperadoMinimo: this.consumoEsperadoMinimo,
            formaControle: this.formaControle,
            motorizado: this.motorizado,
            numeroEixos: this.numeroEixos,
            categoriaCnh: this.categoriaCnh,
            potencia: this.potencia,
            cilindradas: this.cilindradas,
            consumoMedio: this.consumoMedio,
            capacidadeTanque: this.capacidadeTanque,
            tipoEixo: this.tipoEixo,
            numeroPassageiros: this.numeroPassageiros,
            capacidadeCarga: this.capacidadeCarga,
        });
    }

    ngOnInit() {
        this.getCategorias();
        this.getFormasControle();
        this.getTipoDeslocamentos();
        this.getCategoriasCnh();

        this.isNewAutoComplete();
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    changeCategoria() {
        this.bemTipoQuery.where.categoriaId = this.categoriaObject.id;
    }

    onSubmit(evt: any) {
        this.submitted = true;

        if(evt.valid) {
            this.btnSaveDisabled = true;
            var object:any = this._utilService.cloneObject(this.formObject);

            if (this.marcaObject.id) {
                object.marcaId = this.marcaObject.id;
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            if (this.bemTipoObject.id) {
                object.tipoBemId = this.bemTipoObject.id;
            } else {
                this.btnSaveDisabled = false;
                return false;
            }

            if (this.bemSubtipoObject.id) {
                object.subTipoBemId = this.bemSubtipoObject.id;
            } else {
                object.subTipoBemId = null;
            }

            if (this.deslocamentoTipoObject.id) {
                object.tipoDeslocamentoId = this.deslocamentoTipoObject.id;
            } else {
                object.tipoDeslocamentoId = null;
            }

            if (this.formaControleObject.id) {
                object.formaControleId = this.formaControleObject.id;
            } else {
                object.formaControleId = null;
            }

            if (this.categoriaCnhObject.id) {
                object.categoriaExigidaId = this.categoriaCnhObject.id;
            } else{
                object.categoriaExigidaId = null;
            }

            if (object.numeroEixos) {
                object.numeroEixos = this._utilService.checkNumber(object.numeroEixos);
            }

            if (object.potencia) {
                object.potencia = this._utilService.checkNumber(object.potencia);
            }

            if (object.cilindradas) {
                object.cilindradas = this._utilService.checkNumber(object.cilindradas);
            }

            if (object.numeroPassageiros) {
                object.numeroPassageiros = this._utilService.checkNumber(object.numeroPassageiros);
            }

            if (this.formObject.id) {
                this.onEditModelo(object);
            } else {
                this.onAddModelo(object);
            }
        }
    }

    getMarcasObject(object: any) {
        if(object.novo) {
            var thisFormObject: any = this.setObjectBeforeLeave();

            this._modelosService.setSessionStorage(thisFormObject);

            var toOtherFormObject: any = {
                marca: object.text,
                form: modelosStorage
            };
            this._autocompleteService.setSessionStorage(toOtherFormObject, marcasStorage);
            this._marcaNavigationService.goToNew();
        } else {
            this.marcaObject = object;
            this._utilService.setSelectOnFormControl(this.form, 'marca', object);
        }
    }

    getBemTiposObject(object: any) {
        if(object.novo) {
            var thisFormObject: any = this.setObjectBeforeLeave();

            this._modelosService.setSessionStorage(thisFormObject);

            var toOtherFormObject: any = {
                tipo: object.text,
                categoriaId: this.categoriaObject.id,
                form: modelosStorage
            };
            this._autocompleteService.setSessionStorage(toOtherFormObject, bemTiposStorage);
            this._bemTipoNavigationService.goToNew();
        } else {
            this.bemTipoObject = object;
            this._utilService.setSelectOnFormControl(this.form, 'bemTipo', object);
            this.getSubtiposBens();
        }
    }

    private onAddModelo(object: Modelo) {
        this._modeloApiService.onPost(object, this.onDone);
    }

    private onEditModelo(object: Modelo) {
        this._modeloApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            Response.marca = this.marcaObject;
            this.responsModelo = Response;
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }
            this.toLeaveHere();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum modelo encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._modeloApiService.onGetById(id, onDone);
    }

    private setObjectBeforeLeave() {
        var object: any = this.formObject;
        object.marca = this.marcaObject;
        object.tipoBem = this.bemTipoObject;
        object.subTipoBem = this.bemSubtipoObject;
        object.tipoDeslocamento = this.deslocamentoTipoObject;
        object.formaControle = this.formaControleObject;
        object.categoriaExigida = this.categoriaCnhObject;

        return object;
    }

    private setModelToForm() {
        if (this.formObject.marca) {
            this.marcaObject = this.formObject.marca;
            delete this.formObject['marca'];

            if (this.showSelectMarca) {
                let text = this._autocompleteService.getTextSelect2(this.marcaObject, 'marca');
                var selectObject:any = {text: text, id: this.marcaObject.id};

                this._autocompleteService.createOptionOnSelect2(this.marcaSelectId, selectObject);
                this._autocompleteService.setValueOnSelect2(selectObject.id, this.marcaSelectId);
                this._utilService.setSelectOnFormControl(this.form, 'marca', this.marcaObject);
            }
        }

        if (this.formObject.tipoBem) {
            this.bemTipoObject = this.formObject.tipoBem;
            delete this.formObject['tipoBem'];

            let text = this._autocompleteService.getTextSelect2(this.bemTipoObject, 'tipo');
            var selectObject:any = {text: text, id: this.bemTipoObject.id};

            this._autocompleteService.createOptionOnSelect2(this.bemTipoSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.bemTipoSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'bemTipo', this.bemTipoObject);

            if (this.bemTipoObject.categoriaId) {
                if (this.categoriasList.length) {
                    this.setCategoria();
                }
            }

            this.getSubtiposBens();
        }

        if (this.formObject.subTipoBem) {
            this.bemSubtipoObject = this.formObject.subTipoBem;
            delete this.formObject['subTipoBem'];
        }

        if (this.formObject.tipoDeslocamento) {
            this.deslocamentoTipoObject = this.formObject.tipoDeslocamento;
            delete this.formObject['tipoDeslocamento'];

            if (this.deslocamentoTiposList.length) {
                this.setTipoDeslocamento();
            }
        }

        if (this.formObject.formaControle) {
            this.formaControleObject = this.formObject.formaControle;
            delete this.formObject['formaControle'];

            if (this.formasControleList.length) {
                this.setFormaControle();
            }
        }

        if (this.formObject.categoriaExigida) {
            this.categoriaCnhObject = this.formObject.categoriaExigida;
            delete this.formObject['categoriaExigida'];
            this.setCategoriaCnh();
        }
    }

    private getFormasControle() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formasControleList = Response;
                this.formasControleList.unshift({id: null, formaControle: '— Selecione —'});
                this.setFormaControle();
            }
        }.bind(this));

        this._formaControleApiService.onGetAll(onDone);
    }

    private getCategorias() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.categoriasList = Response;
                this.setCategoria();
            }
        }.bind(this));

        this._categoriaApiService.onGetAll(onDone);
    }

    private getCategoriasCnh() {
    var onDone = (function(Response: any) {
        if (!Response.error)  {
            this.categoriasCnhList = Response;
            this.categoriasCnhList.unshift({id: null, categoria: '— Selecione —'});
            this.setCategoriaCnh();
        }
    }.bind(this));

    this._categoriaCnhApiService.onGetAllVeiculo(onDone);
}

    private setCategoria() {
        var x: any, lenX: any;
        this.categoriaObject = this.categoriasList[0];
        for (x = 0, lenX = this.categoriasList.length; x < lenX; x++) {
            if (this.categoriasList[x].id === this.bemTipoObject.categoriaId) {
                this.categoriaObject = this.categoriasList[x];
                break;
            }
        }
    }

    private setCategoriaCnh() {
        var x: any, lenX: any,
            t: any = this.categoriaCnhObject.id;

        if (!t) {
            t = this.categoriasCnhList[0].id;
        }
        for (x = 0, lenX = this.categoriasCnhList.length; x < lenX; x++) {
            if (this.categoriasCnhList[x].id === t) {
                this.categoriaCnhObject = this.categoriasCnhList[x];
                break;
            }
        }
    }

    private setFormaControle() {
        var x: any, lenX: any,
            t: any = this.formaControleObject.id;

        if (!t) {
            t = this.formasControleList[0].id;
        }

        for (x = 0, lenX = this.formasControleList.length; x < lenX; x++) {
            if (this.formasControleList[x].id === t) {
                this.formaControleObject = this.formasControleList[x];
                break;
            }
        }
    }

    private getTipoDeslocamentos() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: any, lenX: any;
                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    Response[x].text = this._deslocamentoTipoService.templateResult(Response[x]);
                }
                this.deslocamentoTiposList = Response;
                this.deslocamentoTiposList.unshift({id: null, text: '— Selecione —'});
                this.setTipoDeslocamento();
            }
        }.bind(this));

        this._deslocamentoTipoApiService.onGetAll(onDone);
    }

    private setTipoDeslocamento() {
        var x: any, lenX: any,
            t: any = this.deslocamentoTipoObject.id;

        if (!t) {
            t = this.deslocamentoTiposList[0].id;
        }

        for (x = 0, lenX = this.deslocamentoTiposList.length; x < lenX; x++) {
            if (this.deslocamentoTiposList[x].id === t) {
                this.deslocamentoTipoObject = this.deslocamentoTiposList[x];
                break;
            }
        }
    }

    private getSubtiposBens() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: any, lenX: any, list: SubtleCrypto[] = [];
                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    if (Response[x].ativo) {
                        list.push(Response[x]);
                    }
                }

                this.bemSubtiposList = list;
                this.bemSubtiposList.unshift({id: null, subTipo: '— Selecione —'});

                this.setSubtipoBem();
            }
        }.bind(this));

        this._bemSubtipoApiService.onGetByTipo(this.bemTipoObject.id, onDone);
    }

    private setSubtipoBem() {
        var x: any, lenX: any,
            t: any = this.bemSubtipoObject.id;

        if (!t) {
            t = this.bemSubtiposList[0].id;
        }

        for (x = 0, lenX = this.bemSubtiposList.length; x < lenX; x++) {
            if (this.bemSubtiposList[x].id === t) {
                this.bemSubtipoObject = this.bemSubtiposList[x];
                break;
            }
        }

        var select: any = document.getElementById("bemSubtipo");
        select.disabled = (this.bemSubtiposList.length) ? false : true;
    }

    private goToList() {
        this._modelosService.clearSessionStorage();
        this._modeloNavigationService.goToList();
    }

    private testSession() {
        var id: number;
        var session: any = this._modelosService.getSessionStorage();
        this._modelosService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            if (id) {
                this.setEditSession();
            } else {
                this.setNewSession();
            }
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setActionTitle(id: any) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setEditNormal(id: number) {
        this.showSelectMarca = true;
        this.getObject(id);
    }

    private setNewNormal() {
        this.marcaObject = this._modelosService.getSessionStorageFatherModule();
        this._utilService.setSelectOnFormControl(this.form, 'marca', this.marcaObject);

        this.setModelToForm();
    }

    private setEditSession() {
        //qndo retornou para continuar a edição
        this.showSelectMarca = true;
        setTimeout(function () {
            this.setModelToForm();
        }.bind(this));
    }

    private setNewSession() {
        //qndo retornou para continuar o cadastro
        this.setModelToForm();
    }

    private isNewAutoComplete() {
        var newAutoComplete: any = this._autocompleteService.getSessionStorage(modelosStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.formObject.modelo = newAutoComplete.modelo;
            this.formObject.marca = newAutoComplete.marca;
            this.bemTipoObject.categoriaId = newAutoComplete.categoriaId;
            this.showSelectMarca = true;

            this.setActionTitle(this.formObject.id);
            setTimeout(function() {
                this.setModelToForm();
            }.bind(this));
        } else {
            //retornando de um cadastro
            this.testSession();
        }
    }

    private toLeaveHere() {
        if (this.returnToOtherForm) {
            this._modelosService.returnToOtherForm(this.otherForm, this.responsModelo);
        } else {
            this.goToList();
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/modelos/modelo-form/modelo-form.component.ts
 **/